<template>
  
  <b-row>
    <b-col>
      <b-card
        style="margin:0;border:1px solid #2980b9;padding:0 10px"
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          style="color: black; font:45px; padding:0 0; padding: 0 1px; cursor: pointer"
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
        >
          <span class="lead collapse-title">
            <strong>DIAGNÓSTICO</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </b-card-header>
        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">

            <DiagnosticosList
              v-if="flagLoad"
              v-model="diagnosticosList"
              small
              noTitle
            />

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { DiagnosticosList } from '@/shared/components';
import { loadRespaldo, saveRespaldo } from '../../helpers';
import { diagnosticosService } from '../../../atencionMedica/services';


export default {
  name: "AtencionDiagnosticos",

  components: {
    DiagnosticosList
  },


  created() {
    this.loadData();
  },

  data() {
    return {
      visibleBody: false,
      diagnosticosList:[],

      flagLoad: false,

      diagnosticosIniciales: [],
    }
  },

  methods: {


    async loadData(){

      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;

      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if(this.idCita){
        const dataLS = loadRespaldo(this.identificadorAtencion, 'diagnosticos');
        this.flagLoad = true;
        if(!dataLS) return;
        this.diagnosticosList = dataLS;
      }

      if(this.tokenAtencion){
        this.loadDiagnosticosEditar() 
      }
    },

    onVisibleBody(value) {
      this.visibleBody = value
    },


    async loadDiagnosticosEditar() {
      const responseDiagnosticos = await diagnosticosService.getByAtencion(this.tokenAtencion);

      if(!responseDiagnosticos){
        this.flagLoad = true;
        return;
      }

      const diagnosticosActivos = responseDiagnosticos.filter( d => d.activo );
      this.diagnosticosIniciales = [...diagnosticosActivos];

      this.diagnosticosList = diagnosticosActivos;
      this.flagLoad = true;
    }
  },

  

  watch: {
    
    diagnosticosList:{
      deep: true,
      handler(newValue) {

        if(this.idCita){
          saveRespaldo(this.identificadorAtencion, 'diagnosticos', newValue);
        }

        if(this.tokenAtencion){
          const diagnoticosObj = {
            inicial: this.diagnosticosIniciales,
            final: newValue
          }

          saveRespaldo(this.identificadorAtencion, 'diagnosticos', diagnoticosObj);
        }

      }
    }
  },

}
</script>
